export default class PrPaginacaoService {
  searchMethod = undefined;
  numberOfPages = 1;
  total = 0;
  perPage = 10;
  currentPage = 0;
  options = {
    maxPages: 10,
    labels: {
      first: '««',
      previous: '«',
      next: '»',
      last: '»»',
    },
  }

  constructor(searchMethod, perPage, _options) {
    if (perPage !== undefined) {
      this.perPage = perPage;
    }

    Object.assign(this.options, _options);

    this.searchMethod = searchMethod;
    // calcula quantas páginas vão ser exibidas na parte intermediaria da paginação
    this.options.maxPagesInner = Math.floor(this.options.maxPages / 2);
  }

  /**
   * Calcula o número de páginas que vai ser exibida baseado no total de
   * itens com a perPage
   *
   * @param {int} total - total de itens
   */
  calcNumberOfPages(total) {
    this.total = total;

    if (total <= 0) {
      this.numberOfPages = 1;
    } else {
      this.numberOfPages = Math.floor(total / this.perPage) + (total % this.perPage > 0 ? 1 : 0);
    }
  }

  /**
   * Verifica as páginas que devem ser exibidas
   */
  pages() {
    const ret = [];

    for (let i = 1; i <= this.numberOfPages; i += 1) {
      if (this.currentPage === i) {
        ret.push(i);
      } else if (this.currentPage <= (this.options.maxPagesInner + 1)) {
        if (i <= this.options.maxPages) {
          ret.push(i);
        }
      } else if ((i >= this.currentPage - this.options.maxPagesInner) &&
            (i <= this.currentPage + this.options.maxPagesInner)) {
        ret.push(i);
      }
    }
    return ret;
  }

  /**
   * Carrega os dados da página anterior
   */
  previousPage() {
    if (this.currentPage > 1) {
      this.searchMethod(this.currentPage - 1);
    }
  }

  /**
   * Carrega os dados da próxima página
   */
  nextPage() {
    if (this.currentPage < this.numberOfPages) {
      this.searchMethod(this.currentPage + 1);
    }
  }

  /**
   * Carrega os dados da página informada
   *
   * @param {int} page - pagina que deve ser carregada
   */
  goToPage(page) {
    if (page >= 1 && page <= this.numberOfPages) {
      this.searchMethod(page);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/widgets/PrPaginacaoService.js